import { GameVars } from "./../GameVars";

export class Button extends Phaser.GameObjects.Image {

    public frameNameOn: string;
    public frameNameOff: string;
    public newScale: number;

    private defaultScale: { x: number, y: number };

    constructor(scene: Phaser.Scene, x: number, y: number, textureAtlas: string, frameNameOff: string, frameNameOn: string = frameNameOff, pixelPerfect?: boolean, needScaleX?: boolean, newScale?: number) {

        super(scene, x, y, textureAtlas, frameNameOff);

        if (pixelPerfect) {
            this.setInteractive({ pixelPerfect: true });
        } else {
            this.setInteractive();
        }

        this.frameNameOn = frameNameOn;
        this.frameNameOff = frameNameOff;

        this.newScale = 1;

        if (newScale) {
            this.newScale = newScale;
            this.setScale(newScale);
        }

        this.on("pointerover", () => {
            this.setFrame(this.frameNameOn);
            this.setScale(needScaleX ? GameVars.scaleX * this.newScale * 1.025 : this.newScale * 1.025, this.newScale * 1.025);
        }, this);

        this.on("pointerout", () => {
            this.setFrame( this.frameNameOff);
            this.setScale(needScaleX ? GameVars.scaleX * this.newScale : this.newScale, this.newScale);
        }, this);

        this.on("pointerdown", () => {
            this.setFrame( this.frameNameOff);
            this.setScale(needScaleX ? GameVars.scaleX * this.newScale : this.newScale, this.newScale);
        }, this);

        this.on("pointerup", () => {
            this.setFrame(this.frameNameOn);
        }, this);
    }

    public onUp(f: Function, context: any): void {
        this.on("pointerup", f, context);
    }

    public onDown(f: Function, context: any): void {
        this.on("pointerdown", f, context);
    }

    public onOver(f: Function, context: any): void {
        this.on("pointerover", f, context);
    }

    public onOut(f: Function, context: any): void {
        this.on("pointerout", f, context);
    }

    public setInflationTween(ratio: number, tween?: boolean, tweenData?: { ease: any, duration: number }): void {

        this.defaultScale = { x: this.scaleX, y: this.scaleY };

        if (tween) {
            if (!tweenData) {
                tweenData = { ease: Phaser.Math.Easing.Cubic.Out, duration: 200 };
            }
        }

        this.on("pointerover", () => {
            if (tween) {
                this.scene.tweens.add({
                    targets: [this],
                    scaleX: this.defaultScale.x * ratio,
                    scaleY: this.defaultScale.y * ratio,
                    ease: tweenData.ease,
                    duration: tweenData.duration,

                });
            } else {
                this.setScale(this.defaultScale.x * ratio, this.defaultScale.x * ratio);
            }
        }, this);

        this.on("pointerout", () => {
            if (tween) {
                this.scene.tweens.add({
                    targets: [this],
                    scaleX: this.defaultScale.x,
                    scaleY: this.defaultScale.y,
                    ease: tweenData.ease,
                    duration: tweenData.duration,

                });
            } else {
                this.setScale(this.defaultScale.x, this.defaultScale.x);
            }
        }, this);

        this.on("pointerodown", () => {
            this.setScale(this.defaultScale.x, this.defaultScale.x);
        }, this);

        this.on("pointerup", () => {
            this.setScale(this.defaultScale.x * ratio, this.defaultScale.x * ratio);
        }, this);
    }
}
